import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import StandaloneOrderModal from './StandaloneOrderModal.vue';

import { ORDER_BEHAVIOR, ORDER_STATUS } from '@rendora/common/types/enums';

// 定义独立订单接口
export interface IStandaloneOrder {
  behavior: ORDER_BEHAVIOR;
  id: number;
  pay_fee: number;
  qr_code_url: string;
  status: ORDER_STATUS;
  rights_name: string;
  start_timestamp: number;
  expired_timestamp: number;
}

// 使用独立订单模态框
export const useSingleOrderModal = (order: IStandaloneOrder, tip: string) => {
  const i18nService = getI18nService();
  const $t = i18nService.t;

  const modal = ModalFactory.create(
    {
      width: 608,
      showHeader: true,
      showCloseButton: true,
      title: $t('ding-yue-orderrightsname', [order.rights_name]),
      content: <StandaloneOrderModal {...order} tip={tip} />,
    },
    Symbol('single-order-modal'),
  );

  return modal;
};
